// RC widget — sync per-bottle price labels with purchase option selection 
(function () {
  function isSubscriptionSelected() {
    const rcHost = document.querySelector('recharge-subscription-widget');
    if (!rcHost || !rcHost.shadowRoot) return false;
    return !!rcHost.shadowRoot.querySelector('.rc-purchase-option__subscription[rc-selected]');
  }

  function updatePerBottlePrices() {
    const isSubscription = isSubscriptionSelected();

    document.querySelectorAll('.opt-label--size[data-pack-count]').forEach(function (label) {
      const packCount = parseInt(label.dataset.packCount, 10);
      if (!packCount) return;

      const priceCents = isSubscription
        ? parseInt(label.dataset.subCents, 10)
        : parseInt(label.dataset.onetimeCents, 10);

      const perBottleCents = Math.round(priceCents / packCount);
      const span = label.querySelector('.opt-label__size');
      if (span) span.textContent = '$' + (perBottleCents / 100).toFixed(2) + '/ bottle';
    });
  }

  function initRCObserver() {
    const rcHost = document.querySelector('recharge-subscription-widget');
    if (!rcHost || !rcHost.shadowRoot) return false;

    new MutationObserver(updatePerBottlePrices).observe(rcHost.shadowRoot, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['rc-selected', 'rc-not-selected']
    });
    updatePerBottlePrices(); // sync labels with initial RC widget state
    return true;
  }

  function waitForRC() {
    if (initRCObserver()) return;

    // RC widget renders async — watch for it to appear in the DOM
    const bodyObserver = new MutationObserver(function (_, obs) {
      if (initRCObserver()) obs.disconnect();
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { bodyObserver.disconnect(); }, 10000);
  }

  function init() {
    waitForRC();

    // product-info.js swaps variant-selects HTML (AJAX re-render) then fires variantChange.
    // Re-apply subscription state after the new labels are in the DOM.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, updatePerBottlePrices);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// Review stars — show 4.5 when average is above 4 but below 4.5 (e.g. 4.15 → 4.5)
// Handles Judge.me preview badges (PDP) and Dawn metafield stars (collection cards)
(function () {
  function displayRating(rating) {
    if (rating > 4.0 && rating < 4.5) return 4.5;
    return Math.round(rating * 2) / 2;
  }

  function setJudgeMeStarDisplay(starsContainer, score) {
    const stars = starsContainer.querySelectorAll('.jdgm-star');
    if (stars.length !== 5) return;

    stars.forEach(function (star, i) {
      star.classList.remove('jdgm--on', 'jdgm--half', 'jdgm--off');
      const starValue = i + 1;
      if (score >= starValue) {
        star.classList.add('jdgm--on');
      } else if (score >= starValue - 0.5) {
        star.classList.add('jdgm--half');
      } else {
        star.classList.add('jdgm--off');
      }
    });

    starsContainer.dataset.score = String(score);
    starsContainer.setAttribute('aria-label', score + ' stars');
  }

  function setDawnStarDisplay(ratingEl, starEl, score, scaleMax) {
    const floor = Math.floor(score);
    const decimal = score - floor;

    starEl.style.setProperty('--rating', floor);
    starEl.style.setProperty('--rating-decimal', decimal);
    ratingEl.setAttribute('aria-label', score + ' out of ' + scaleMax + ' stars');
  }

  function parseDawnRating(ratingBlock) {
    const textEl = ratingBlock.parentElement && ratingBlock.parentElement.querySelector('.rating-text span[aria-hidden="true"]');
    if (!textEl) return null;

    const match = textEl.textContent.trim().match(/^([\d.]+)\s*\/\s*([\d.]+)/);
    if (!match) return null;

    const rating = parseFloat(match[1]);
    const scaleMax = parseFloat(match[2]);
    if (isNaN(rating) || isNaN(scaleMax)) return null;

    return { rating: rating, scaleMax: scaleMax };
  }

  function adjustReviewStars(root) {
    const scope = root || document;

    scope.querySelectorAll('.jdgm-prev-badge[data-average-rating]').forEach(function (badge) {
      const rating = parseFloat(badge.dataset.averageRating);
      if (isNaN(rating) || rating <= 4.0) return;

      const display = displayRating(rating);
      if (display === rating) return;

      const starsContainer = badge.querySelector('.jdgm-prev-badge__stars');
      if (!starsContainer) return;

      const currentScore = parseFloat(starsContainer.dataset.score);
      if (currentScore === display) return;

      setJudgeMeStarDisplay(starsContainer, display);
    });

    scope.querySelectorAll('.card-wrapper .rating').forEach(function (ratingEl) {
      const parsed = parseDawnRating(ratingEl);
      if (!parsed || parsed.rating <= 4.0) return;

      const display = displayRating(parsed.rating);
      if (display === parsed.rating) return;

      const starEl = ratingEl.querySelector('.rating-star');
      if (!starEl) return;

      const floor = Math.floor(display);
      const decimal = display - floor;
      const currentFloor = parseInt(starEl.style.getPropertyValue('--rating'), 10);
      const currentDecimal = parseFloat(starEl.style.getPropertyValue('--rating-decimal'));
      if (currentFloor === floor && currentDecimal === decimal) return;

      setDawnStarDisplay(ratingEl, starEl, display, parsed.scaleMax);
    });
  }

  function initReviewStars() {
    adjustReviewStars();

    new MutationObserver(function () {
      adjustReviewStars();
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReviewStars);
  } else {
    initReviewStars();
  }
})();
